export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  const defaultUrls = config.state.paramsClient.display_default_urls;
  const URL =
    defaultUrls && defaultUrls.linkedin !== ''
      ? defaultUrls.linkedin
      : 'https://www.linkedin.com/embed/feed/update/urn:li:share:6544966475646590976';

  domc.addType('linkedin_widget', {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': 'linkedin',
          tagName: 'div',
          src:
            '<iframe src="' +
            URL +
            '" height="100%" width="100%" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>',
          resizable: {
            minDim: 10,
          },
          traits: [
            {
              type: 'text',
              label: 'src',
              name: 'src',
              changeProp: 1,
              attributes: { 'data-related-type': 'linkedin' },
            },
          ],
        }),
        init() {
          this.listenTo(this, 'change:src', this.updateSrc);
        },
        toHTML() {
          return this.view && this.view.el.getAttribute('data-gjs-type') === 'linkedin_widget'
            ? this.view.el.outerHTML
            : '';
        },
        updateSrc() {
          let src = this.get('src');
          src = src.replace(/(height|width)="\d+"/g, val => {
            return val.replace(/\d+/g, '100%');
          });
          this.set('src', src);
          this.view.getIframe();
          this.view.render();
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName === 'div') {
            result = { type: 'linkedin_widget' };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      getIframe() {
        var ifrm = document.createElement('div');
        ifrm.style.height = '100%';
        ifrm.style.width = '100%';
        ifrm.innerHTML = this.model.get('src');
        this.iframe = ifrm;
        return this.iframe;
      },

      render(...args) {
        defaultView.prototype.render.apply(this, args);
        if (
          this.el.getElementsByTagName('DIV').length === 0 ||
          this.el.querySelector('.content_iframe')
        ) {
          this.getIframe();
        }
        this.el.appendChild(this.getIframe());
        return this;
      },
    }),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/linkedin/components.js